import { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { createValidator, required } from 'lib/form-validation'
import { Checkbox, Form, FormButtonGroup, Input } from 'components/forms'

import css from './share-by-email-form.scss'
import { shareByEmail } from '../../actions'

export const validate = createValidator({
  fromName: [required],
  message: [required],
  toEmails: [required],
})

export const defaultMessage = (name) => {
  return `Hi!

I've created a Babylist registry to help keep track of items needed for the little one's arrival and wanted to share it with you!

Best,
${name}`
}

class ShareByEmailForm extends Component {
  static propTypes = {
    error: PropTypes.object,
    fields: PropTypes.shape({
      fromName: PropTypes.object,
      copyMe: PropTypes.object,
      message: PropTypes.object,
      registryId: PropTypes.object,
      toEmails: PropTypes.object,
    }),
    handleSubmit: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func,
    registryShareUrl: PropTypes.string.isRequired,
    registryTitle: PropTypes.string.isRequired,
    submitting: PropTypes.bool,
  }

  render() {
    const {
      error,
      fields: { fromName, copyMe, message, toEmails },
      handleSubmit,
      onHide,
      registryShareUrl,
      registryTitle,
      submitting,
    } = this.props

    return (
      <Form error={error} onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
        <div className={classNames('mbl', css.headingWrapper)}>
          <div className={classNames('hidden-xs', css.logoWrapper)}>
            <div className={classNames('bl-img-logo', css.logo)}></div>
          </div>
          <div className={css.registryInfoWrapper}>
            <strong>{registryTitle}</strong>
            <br />
            <span className={css.registryUrl}>{registryShareUrl}</span>
          </div>
        </div>
        <Input
          {...fromName}
          error={fromName.touched ? fromName.error : null}
          label="Your Full Name"
        />
        <Input
          {...toEmails}
          error={toEmails.touched ? toEmails.error : null}
          label="Your Friend's Email Addresses"
          placeholder="Use commas to separate email addresses."
          type="textarea"
        />
        <Input
          {...message}
          error={message.touched ? message.error : null}
          label="Your Message"
          rows={7}
          type="textarea"
        />
        <Checkbox {...copyMe} label="Send me a copy of this email." />
        <FormButtonGroup
          onClickSecondary={onHide}
          submitting={submitting}
          textPrimary="Send Email"
        />
      </Form>
    )
  }

  handleSubmit(values, dispatch) {
    return dispatch(shareByEmail(values))
  }
}

export default ShareByEmailForm
